import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { API_FETCH } from '../../services';
import { ENDPOINTS } from '../../constants/endpoints';

export interface ShiftKpiResponse {
    totalPostedShifts: number;
    notGrabbedShifts: number;
    approvedShifts: number;
    rejectedShifts: number;
    canceledShifts: number;
    grabbedShifts: number;
    openShifts: number;
    vtoShifts: number;
    swapShifts: number;
    openPercentage: string;
    vtoPercentage: string;
    swapPercentage: string;
}

interface KpiState {
    kpiData: ShiftKpiResponse | null;
    loading: boolean;
    error: string | null;
}

const initialState: KpiState = {
    kpiData: null,
    loading: false,
    error: null,
};

// ========================================
// ASYNC THUNKS
// ========================================
/**
 * Fetch shift KPI metrics for a site with optional date range
 * GET /api/reports/kpi?siteCd=XX&startDate=YYYY-MM-DD&endDate=YYYY-MM-DD
 */
export const fetchShiftKpi = createAsyncThunk(
    'Kpi/fetchShiftKpi',
    async ({ siteCd, startDate, endDate }: { siteCd: string; startDate?: string; endDate?: string }, { rejectWithValue }) => {
        try {
            const params: string[] = [`siteCd=${siteCd}`];
            if (startDate) params.push(`startDate=${startDate}`);
            if (endDate) params.push(`endDate=${endDate}`);

            const url = `${ENDPOINTS.GET_KPI_REPORT}?${params.join('&')}`;
            const response = await API_FETCH(url);
            console.log('✅ KPI API Response:', response);
            return response;
        } catch (error: any) {
            console.error('❌ KPI API Error:', error);
            return rejectWithValue(error?.message || 'Failed to fetch KPI data');
        }
    }
);

// ========================================
// SLICE
// ========================================
const kpiSlice = createSlice({
    name: 'kpi',
    initialState,
    reducers: {
        clearError: (state) => {
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchShiftKpi.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchShiftKpi.fulfilled, (state, action) => {
                state.loading = false;
                state.kpiData = action.payload;
            })
            .addCase(fetchShiftKpi.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
            });
    },
});

export const { clearError } = kpiSlice.actions;
export default kpiSlice.reducer;